<template>
    <div :class="spacerClass" @click="emitEvent({ name: 'click', payload: $event })">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        props: {
            height: { type: String, required: true },
            isCenter: { type: Boolean, default: false },
        },

        computed: {
            spacerClass() {
                return {
                    'content-spacer': true,
                    'content-spacer--is-center': this.isCenter,
                    [`content-spacer--height-${this.height}`]: true,
                }
            },
        },
    }
</script>
